import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import dayjs from 'dayjs';
import './ScheduleSubmissionSearchFilterStyle.css';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomDatePicker from '../../../../Components/custom_components/CustomDatePicker/CustomDatePicker';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { get_worksite_with_out_pagination } from '../../../../config/Worksite/siteApis';
import { get_technology_with_out_pagination } from '../../../../config/Resource/technologyApis';
import { get_workforce_with_out_pagination } from '../../../../config/Resource/workforceApis';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { FaFileInvoice } from 'react-icons/fa';
import { invoiceStatusOptions } from '../../../../utils/constants';

function ScheduleSubmissionSearchFilter({ isSendPermission, filterValues, handleClearSelectedIds, tableTitle, isAddEdiModalOpen, handleAddEditModal, searchFilter, handleSubmitModal, on_change_value, on_page_count_update }) {

    const [technologyListing, setTechnologyListing] = useState([]);
    const [worksiteListing, setWorksiteListing] = useState([]);
    const [workforceListing, setWorkforceListing] = useState([]);

    const fetchTechnologies = async () => {
        try {
            const response = await get_technology_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.TechnologiesName,
                    value: item?.TechnologiesTypeId
                }));

                // Set the transformed data to the state
                setTechnologyListing(transformedData || []);
            } else {
                setTechnologyListing([]);
            }
        } catch (error) {
            console.error('Error fetching technologies:', error);
            setTechnologyListing([]);
        }
    };

    // FETCH WORKSITES 
    const fetchSites = async () => {
        try {
            const response = await get_worksite_with_out_pagination();

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.worksiteName,
                    value: item?.WorksiteID
                }));

                // Set the transformed data to the state
                setWorksiteListing(transformedData || []);
            } else {
                setWorksiteListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorksiteListing([]);
        }
    };

    // FETCH fetchWorkforce
    const fetchWorkforce = async () => {
        try {
            const response = await get_workforce_with_out_pagination();

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.UD_name,
                    value: item?.UD_ID
                }));

                // Set the transformed data to the state
                setWorkforceListing(transformedData || []);
            } else {
                setWorkforceListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorkforceListing([]);
        }
    };

    // FOR GET TECHNOLOGIES FROM LIST
    useEffect(() => {
        fetchSites()
        fetchWorkforce()
        fetchTechnologies();
    }, []);


    const formik = useFormik({
        initialValues: {
            ScheduleCode: '',
            Survey_from_date: '',
            Survey_end_date: '',
            TechnologyId: '',
            WorksiteId: '',
            // EmployeeId: '',
            // EquipmentID: '',
            inv_status: 0,
        },
        // onSubmit: (values) => {
        //     searchFilter(values);
        //     handleClearSelectedIds()
        // },
    });

    const resetFilter = () => {
        formik.resetForm();
        handleClearSelectedIds()

        on_change_value(1)
        on_page_count_update(25)

        searchFilter(
            {
                ScheduleCode: '',
                Survey_from_date: '',
                Survey_end_date: '',
                TechnologyId: '',
                WorksiteId: '',
                // EmployeeId: '',
                // EquipmentID: '',
                inv_status: 0,
            }
        )
    }

    const breadcrumbs = ['Finance', tableTitle];
    return (
        <div className="schedule-search-filter-container">
            <div className="schedule-search-filter-sub-container">
                <div className="schedule-search-filter-header">
                    <div className="schedule-search-filter-left">
                        <div className="schedule-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>

                    <div className="schedules-search-filter-right">
                        {/* NOT PAID */}
                        {/* {filterValues?.inv_status === 0 && isSendPermission && <CustomAddButton label="Invoice" onClick={handleSubmitModal} Icon={FaFileInvoice} />} */}
                        <CustomAddButton label="Invoice" onClick={handleSubmitModal} Icon={FaFileInvoice} isDisable={!(filterValues?.inv_status === 0 && isSendPermission)} />

                    </div>
                </div>
                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            {/* Search fields */}
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="ScheduleCode"
                                    placeholder="Enter Code"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.ScheduleCode}
                                    width="200px"
                                />
                            </Grid>


                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="TechnologyId"
                                    placeholder="Select Technology"
                                    options={technologyListing}
                                    value={technologyListing.find((tech) => tech.value === formik.values.TechnologyId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("TechnologyId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.TechnologyId && Boolean(formik.errors.TechnologyId)}
                                    helperText={formik.touched.TechnologyId && formik.errors.TechnologyId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid>

                            {/* <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="EmployeeId"
                                    placeholder="Select Workforce"
                                    options={workforceListing}
                                    value={workforceListing.find((employee) => employee.value === formik.values.EmployeeId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("EmployeeId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.EmployeeId && Boolean(formik.errors.EmployeeId)}
                                    helperText={formik.touched.EmployeeId && formik.errors.EmployeeId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid> */}

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="WorksiteId"
                                    placeholder="Select Worksite"
                                    options={worksiteListing}
                                    value={worksiteListing.find((worksite) => worksite.value === formik.values.WorksiteId) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("WorksiteId", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.WorksiteId && Boolean(formik.errors.WorksiteId)}
                                    helperText={formik.touched.WorksiteId && formik.errors.WorksiteId}
                                    isDisabled={false}
                                    isMulti={false} // Single select
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="inv_status"
                                    placeholder="Select Status"
                                    options={invoiceStatusOptions}
                                    value={
                                        invoiceStatusOptions?.find(option => option?.value === formik?.values?.inv_status) ||
                                        invoiceStatusOptions?.find(option => option?.value === 0)
                                    }
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("inv_status", selectedOption ? selectedOption.value : 0);
                                        searchFilter({ ...formik.values, inv_status: selectedOption ? selectedOption.value : 0 });
                                        handleClearSelectedIds()
                                    }}
                                    onBlur={formik.handleBlur}
                                    isClearable={false}
                                    isMulti={false} // Set to false for single-select
                                    width="250px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="Survey_from_date"
                                    label="From Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("Survey_from_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.Survey_from_date, "DD-MM-YYYY")}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomDatePicker
                                    name="Survey_end_date"
                                    label="End Date"
                                    onChange={(date) => {
                                        formik.setFieldValue("Survey_end_date", date);
                                    }}
                                    onBlur={formik.handleBlur}
                                    value={dayjs(formik.values.Survey_end_date, "DD-MM-YYYY")}
                                    minDate={dayjs(formik.values.Survey_from_date, "DD-MM-YYYY")} // Set minimum date

                                    width="200px"
                                />
                            </Grid>

                        </div>
                        {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    handleClearSelectedIds()
                                    on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default ScheduleSubmissionSearchFilter;
